export enum PRESCRIPTION_FROM_TYPES {
  SATELLITE = 'heatmaps',
  SOILMAP = 'soilmaps',
  YIELDMAP = 'yieldmaps',
  NITROGEN = 'nitrogenmaps',
  BIOMASS = 'biomassmaps',
  POTENTIAL = 'potentialmaps',
}
